import { useTranslator } from "../i18n/translation.tsx";
import classes from "./powered-by-brick-me.module.css";

function PoweredByBrickMe() {
	const t = useTranslator();
	return (
		<span className={classes["powered-by-brick-me"]}>
			{t("Powered by brick.me")}
		</span>
	);
}

export default PoweredByBrickMe;
